export const DATA = t => ({
  cash_movements: [
    {
      title: t('modal:report_reference_modal.date'),
      description: t('modal:report_reference_modal.cash_movements_date_desc'),
    },
    {
      title: t('modal:report_reference_modal.type'),
      description: t('modal:report_reference_modal.cash_movements_type_desc'),
    },
    {
      title: t('modal:report_reference_modal.description'),
      description: t(
        'modal:report_reference_modal.cash_movements_description_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.amount'),
      description: t('modal:report_reference_modal.cash_movements_amount_desc'),
    },
    {
      title: t('modal:report_reference_modal.balance'),
      description: t(
        'modal:report_reference_modal.cash_movements_balance_desc',
      ),
    },
  ],
  portfolio_movements: [
    {
      title: t('modal:report_reference_modal.date'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_date_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.round'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_round_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.claim'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_claim_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.opening_principal'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_opening_principal_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.invested'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_invested_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.principal_repaid'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_principal_repaid_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.interest_received'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_interest_received_desc',
      ),
    },
    {
      title: t('modal:report_reference_modal.closing_principal'),
      description: t(
        'modal:report_reference_modal.portfolio_movements_closing_principal_desc',
      ),
    },
  ],
});
